<template>
    <div>
        <div v-for="(block, index) in blocks" :key="index" class="block position-relative">
            <button type='button' class="delete bg-danger rounded-circle text-white" @click="$emit('remove', index, blocks)">
                <font-awesome-icon :icon="['fas', 'times']" />
            </button>
<!--            <button type="button" class="moveup move-btn rounded-circle bg-light" @click="moveBlockUp(index, blocks)">-->
<!--                <font-awesome-icon :icon="['fas','caret-up']" size="lg"></font-awesome-icon>-->
<!--            </button>-->
<!--            <button type="button" class="movedown move-btn rounded-circle bg-light" @click="moveBlockDown(index, blocks)">-->
<!--                <font-awesome-icon :icon="['fas','caret-down']" size="lg"></font-awesome-icon>-->
<!--            </button>-->
            <Html v-if="block.type == 'html'" :block.sync="block"/>
            <RawBuilder v-if="block.type == 'raw'" :block.sync="block" />
            <DoubleColumn v-if="block.type == 'double_column'" :block.sync="block" />
            <WYGBuilder v-if="block.type == 'wyg'" :block.sync="block" />
            <StudentMaterialsBuilder v-if="block.type == 'student_materials'" :block.sync="block" />
            <TeacherMaterialsBuilder v-if="block.type == 'teacher_materials'" :block.sync="block" />
            <OnlineBuilder v-if="block.type == 'online'" :block.sync="block" />
            <SSLandingBuilder v-if="block.type == 'ss_landing'" :block.sync="block" />
            <FlipBook v-if="block.type == 'flipbook'" :block.sync="block"/>
            <StaticPage v-if="block.type == 'static'" :block.sync="block"/>
            <Standards v-if="block.type == 'standards'" :block.sync="block"/>
        </div>
    </div>
</template>

<script>

import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
import TipTapEditor from "@/components/tiptap/TipTapEditor";
import RawBuilder from "@/components/dashboard/storeadmin/blocks/Raw";
import WYGBuilder from "@/components/dashboard/storeadmin/blocks/WhatYouGet";
import TeacherMaterialsBuilder from "@/components/dashboard/storeadmin/blocks/TeacherMaterials";
import StudentMaterialsBuilder from "@/components/dashboard/storeadmin/blocks/StudentMaterials";
import NationalMaterialsBuilder from "@/components/dashboard/storeadmin/blocks/NationalMaterials";
import OnlineBuilder from "@/components/dashboard/storeadmin/blocks/Online";
import ScienceBlurbBuilder from "@/components/dashboard/storeadmin/blocks/ScienceBlurb";
import SSLandingBuilder from "@/components/dashboard/storeadmin/blocks/SSLanding";
import DoubleColumn from "@/components/dashboard/storeadmin/blocks/DoubleColumn";
import FlipBook from "@/components/dashboard/storeadmin/blocks/FlipBook";
import Html from "@/components/dashboard/storeadmin/blocks/Html";
import StaticPage from "@/components/dashboard/storeadmin/blocks/StaticPage.vue";
import Standards from "@/components/dashboard/storeadmin/blocks/Standards";
export default {
    name: "StateProductBlock",
    components: {
        Standards,
        StaticPage,
        Html,
        FlipBook,
        DoubleColumn,
        TipTapEditor,
        EditorBlock,

        RawBuilder,
        WYGBuilder,
        TeacherMaterialsBuilder,
        StudentMaterialsBuilder,
        NationalMaterialsBuilder,
        OnlineBuilder,
        ScienceBlurbBuilder,
        SSLandingBuilder
    },
    props: {
        messages: Object,
        page: String,
        blocks: Array,
        noDesc: {
            type: Boolean,
            default: false,
        },
        blockName: String,
    },
    computed: {
        navKey() {
            return this.page;
        },
        descKey() {
            return `${this.page}_description`;
        }
    },
    methods: {
        moveBlockDown(index, blocks) {
            if (index >= blocks.length-1)
                return;

            let a = blocks[index];
            blocks[index] = blocks[index+1];
            blocks[index+1] = a;
            this.$emit('movedown', index, blocks);
            this.$forceUpdate();
        },

        moveBlockUp(index, blocks) {
            if (index == 0)
                return;

            let a = blocks[index];
            blocks[index] = blocks[index-1];
            blocks[index-1] = a;
            this.$emit('moveup', index, blocks);
            this.$forceUpdate();
        },
    }
}
</script>

<style scoped>

</style>